import { render, staticRenderFns } from "./OfferedProductModalContent.vue?vue&type=template&id=f8b37bb8&"
import script from "./OfferedProductModalContent.vue?vue&type=script&lang=js&"
export * from "./OfferedProductModalContent.vue?vue&type=script&lang=js&"
import style0 from "./OfferedProductModalContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports